var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "#323338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6864",
    "data-name": "Path 6864",
    d: "M22.03,5.8a1.284,1.284,0,0,0-1.818,0l-6.3,6.292-6.3-6.3A1.286,1.286,0,0,0,5.785,7.6l6.3,6.3-6.3,6.3A1.286,1.286,0,0,0,7.6,22.03l6.3-6.3,6.3,6.3a1.286,1.286,0,0,0,1.818-1.818l-6.3-6.3,6.3-6.3A1.292,1.292,0,0,0,22.03,5.8Z",
    transform: "translate(-5.407 -5.408)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/X_icon.ee6afaf9c58feeb4c7fd29ac3c4f336e.svg";
export { ForwardRef as ReactComponent };